import Dispatcher from "events-dispatch";
import { apiFetch } from "../../services/api-fetch";
import debounce from "../../services/helpers/debounce";
import { triggerEvent } from "../../services/helpers/trigger-event";

class SuggestBlock {
    static init() {
        let blocks = Array.from(document.querySelectorAll('.suggest-block'));
        blocks.forEach(block => {
            if (block.suggestBlock) return;
            new SuggestBlock(block);
        });
    }

    constructor(el) {
        new Dispatcher(this);
        this.nodes = this._DOMInit(el);
        this.nodes.element.suggestBlock = this;

        this.defaultList = Array.from(this.nodes.list.querySelectorAll('.suggest-block__item'));

        this.action = this.nodes.element.dataset.action;
        this.fieldName = this.nodes.element.dataset.field || "text";
        this.token = this.nodes.element.dataset.token || false;

        this.value = this.nodes.text.value;
    }

    _DOMInit(el) {
        let text = el.querySelector('.suggest-block__text');
        let value = el.querySelector('.suggest-block__value');
        let list = el.querySelector('.suggest-block__list');

        value.addEventListener("setValue", () => {
            text.value = value.value;
        });

        let fetch = debounce((text) => {
            this._fetchItems(text);
        }, 400);

        text.addEventListener('input', e => {

            if (!text.value) {
                value.value = '';
                this._clear();
                return;
            }
            fetch(text.value);
        });

        // text.addEventListener('change', e => {
        //     if (text.value) this._onSelectItem({
        //         text: text.value,
        //         value: text.value
        //     })
        // });

        list.addEventListener('click', e => {
            let item = e.target.closest('.suggest-block__item');

            if (item) {
                this._onSelectItem({
                    text: item.dataset.text,
                    value: item.dataset.value
                }, item);
            }
        });

        document.addEventListener('click', e => {

            if (!el.contains(e.target)) {
                if (!this.nodes.list.classList.contains('hidden')) {
                    this._onSelectItem({
                        text: this.nodes.text.value,
                        value: this.nodes.text.value
                    })
                    this.nodes.list.classList.add('hidden');
                }

            }


        })

        return {
            element: el,
            text: text,
            value: value,
            list: list,
        }
    }

    showFilteredItems(text) {
        this.defaultList.forEach(item => {
            let itemText = item.dataset.text;
            item.style.display = itemText.indexOf(text) === -1 ? "none" : "";
        });
        this.nodes.list.classList.remove('hidden');
    }

    _fetchItems(text) {
        this.trigger('fetch', text);

        if (!this.action) {
            if (this.defaultList.length) this.showFilteredItems(text);
            return;
        }

        if (!text) {
            this._clear();
            return;
        }

        let data = new FormData();
        data.append(this.fieldName, text);

        if (this.token) {
          data.append("token", this.token);
        }

        apiFetch(this.action, {
            method: "POST",
            body: data
        })
        .then(res => {
            if (res.success) {
                this.updateList(res.html);
            } else {
                this.updateList('');
            }
        })
        .catch(err => {
            console.error(err);
            this.updateList('');
        });
    }

    updateList(html) {
        this.nodes.list.innerHTML = html;

        this.nodes.list.classList.toggle('hidden', !html);
    }

    _onSelectItem(itemData, item) {
        this.nodes.text.value = itemData.text;
        this.nodes.value.value = itemData.value;

        this.value = itemData.value;

        triggerEvent(this.nodes.value, "change");
        this.trigger("change", { item, itemData });

        this.nodes.list.classList.add('hidden');
    }

    _clear() {
        this.updateList('');
        this.nodes.text.value = "";
        this.nodes.value.value = "";

        this.value = "";

        triggerEvent(this.nodes.value, "change");
        this.trigger("change", null);
        this.nodes.list.classList.add('hidden');
    }
}

export default SuggestBlock;
